import {AfterViewInit, Component, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PresenceState } from 'src/app/state/presence.reducer';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromPresence from '../../../state/presence.reducer';
import * as ConferencingActions from '../../../state/conferencing.actions';
import { CallType } from 'src/app/state/conferencing.reducer';
import { Resident } from '../../../core/models/resident.model';
import {MatSort} from '@angular/material/sort';
import {Site} from '../../../core/models/site.model';
import {MatTableDataSource} from '@angular/material/table';
import {LoggerService} from '../../../core/services/logger.service';
import * as SiteSelectors from '../../../manager/sites/state/site.selectors';
import * as UserSelectors from '../../../login/state/user.selectors';

@Component({
    selector: 'cm-request-call-dialog',
    templateUrl: 'request-call-dialog.component.html',
    styleUrls: ['request-call-dialog.component.scss']
})
export class RequestCallDialogComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort) sort: MatSort;
  public dialogRef: MatDialogRef<RequestCallDialogComponent>;

  onlineResidents$: Observable<Resident[]>;
  sites$: Observable<Site[]>;
  dataSource = new MatTableDataSource<Resident>();

  customerPermissions$: Observable<string[]>;
  sitePermissions$: Observable<Record<number, string[]>>;
  displayedColumns: string[] = [
    'avatar',
    'first_name',
    'last_name',
    'username',
    'site',
    'screen',
    'call'
  ];

  currentFilter = '';
  selectedSiteId: number | null = null;

  constructor(
    private readonly store$: Store<PresenceState>,
    private readonly viewContainerReference: ViewContainerRef,
    private readonly logger: LoggerService
  ) {}

  ngOnInit(): void {
    this.onlineResidents$ = this.store$.select(
      fromPresence.selectAvailableConferencingResidents
    );
    this.sites$ = this.store$.select(SiteSelectors.selectSitesWithViewResidentPermissions);
    this.customerPermissions$ = this.store$.select(
      UserSelectors.selectCustomerPermissions
    );

    this.sitePermissions$ = this.store$.select(
      SiteSelectors.selectSitePermissions
    );

    this.onlineResidents$.subscribe(residents => {
      this.dataSource.data = residents;
    });

    this.dataSource.filterPredicate = (data: Resident, filter: string) => {
      const { text, siteId } = JSON.parse(filter);

      if (siteId && (data.site as Site).id !== siteId) {
        return false;
      }

      // If no filter, show the resident (already filtered by active above)
      if (!text) {
        return true;
      }

      // Otherwise, apply text filter
      return (
        data.first_name?.toLowerCase().includes(text) ||
        data.last_name?.toLowerCase().includes(text) ||
        data.username?.toLowerCase().includes(text) ||
        (data.site as Site).name.toLowerCase().includes(text)
      );
    };
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }

  onSiteFilterChange(siteId: number | null): void {
    this.selectedSiteId = siteId;
    this.updateFilter();
  }

  applyFilter(filterValue: string): void {
    this.currentFilter = filterValue;
    this.updateFilter();
  }

  updateFilter(): void {
    this.dataSource.filter = JSON.stringify({
      text: this.currentFilter.trim().toLowerCase(),
      siteId: this.selectedSiteId
    });
  }

  requestCall(user): void {
    this.store$.dispatch(
      ConferencingActions.showCallViewer({
        callType: CallType.OUTBOUND,
        remoteUser: user,
      })
    );
    this.dialogRef.close();
  }
}
